module.exports = __webpack_public_path__ + "static/ff_grad_mobile-bd2b840c0f7b2718f4a96c4865b75ce7.svg";